import { Button, Col, Row, VerticalLine } from "components/primitives";
import { ToggleSetting } from "components/settings";
import { FC, useEffect } from "react";
import styled from "styled-components";

import { PhonemeGroupData } from "./phonemes";

interface Props {
  phonemeData: PhonemeGroupData;
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
  disabledSounds: string[];
  setSoundDisabled: (sound: string, disabled: boolean) => void;
  setAllEnabled: () => void;
  setAllDisabled: () => void;
}

export const SinglePhonemeSetting: FC<Props> = ({
  phonemeData,
  enabled,
  setEnabled,
  disabledSounds,
  setSoundDisabled,
  setAllEnabled,
  setAllDisabled,
}) => {
  useEffect(() => {
    if (enabled) {
      setAllEnabled();
    }
  }, [enabled]);

  const soundClicked = (index: number) => {
    const sound = phonemeData.phonemes[index].sounds.join("_");
    setSoundDisabled(sound, !disabledSounds.includes(sound));
  };

  return (
    <OuterContainer>
      <ToggleSetting
        setData={setEnabled}
        info={{ label: phonemeData.name, noMargin: true }}
        data={enabled}
        state={{}}
        settings={{}}
        updateAnyWidgetSetting={() => {}}
      />
      {enabled && (
        <>
          <p>Enable / disable single sounds</p>
          <InnerContainer>
            {phonemeData.phonemes.map((phoneme, index) => (
              <PhonemeButton
                key={index}
                color={phonemeData.color}
                isDisabled={disabledSounds.includes(phonemeData.phonemes[index].sounds.join("_"))}
                onClick={() => soundClicked(index)}
              >
                {phoneme.sounds.join("_")}
              </PhonemeButton>
            ))}
          </InnerContainer>
          <Row>
            <LinkButton onClick={setAllEnabled}>Select All</LinkButton>
            <VerticalLine />
            <LinkButton onClick={setAllDisabled}>Select None</LinkButton>
          </Row>
        </>
      )}
    </OuterContainer>
  );
};

const OuterContainer = styled(Col)`
  gap: 15px;
  margin-bottom: 20px;
`;

const InnerContainer = styled(Row)`
  flex-wrap: wrap;
  gap: 5px;
`;

const PhonemeButton = styled(Button)<{ color: string; isDisabled: boolean }>`
  width: 35px;
  height: 35px;
  background-color: ${(props) => (props.isDisabled ? "#F0F0F0" : props.color)};
  color: ${(props) => (props.isDisabled ? "var(--secondary)" : "black")};
  font-size: 9pt;
  font-weight: 600;
  box-shadow: none;
`;

const LinkButton = styled.p`
  color: var(--primary);

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
